import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import { removeAllTokens } from '../utils/storage';

import { BASE_URL } from '../constants';

const MySwal = withReactContent(Swal);

export const headers = {
  'Content-type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
  'Provider-Id': localStorage.getItem('providerId'),
};

const Axios = axios.create({
  baseURL: BASE_URL,
  headers,
});

Axios.interceptors.response.use(
  (response) => {
    if (response?.data?.data?.accessToken) {
      Axios.defaults.headers.Authorization = `Bearer ${response?.data.data.accessToken}`;
      Axios.defaults.headers['Provider-Id'] = response?.data.data?.userInfo?.providerIds[0];
    }
    return response;
  },
  async (error) => {
    console.log('INTERCEPTOR: ', error);
    const errorResponse = {
      ...error?.response?.data,
    };

    if (error?.response?.status === 401 && !window.location.pathname.includes('/auth')) {
      removeAllTokens();
      window.location.assign('/');
      return false;
    }
    MySwal.fire({
      title: <p>{errorResponse?.message}</p>,
      icon: 'error',
    });
    return Promise.reject(errorResponse || error);
  }
);
export default Axios;
